import {
  TollFreePhoneNumberProvisionRequestSchema,
  TollFreePhoneNumberProvisionResponseSchema,
} from "@redotech/redo-model/phone/phone-number";

export const provisionTollFreePhoneNumber = {
  name: "provisionTollFreePhoneNumber" as const,
  input: TollFreePhoneNumberProvisionRequestSchema,
  output: TollFreePhoneNumberProvisionResponseSchema,
};
